import React from 'react'
import { Icon } from 'antd'
import './AudioModeToggle.scss'

const AudioModeToggle = ({ mode, onChange }) => {
  return (
    <div className="audio-mode-toggle">
      <div
        className={`toggle-option ${mode === 'easy' ? 'active' : ''}`}
        onClick={() => onChange({ target: { value: 'easy' } })}
      >
        <Icon
          type="thunderbolt"
          theme={mode === 'easy' ? 'filled' : 'outlined'}
        />
        Voice over
      </div>
      <div
        className={`toggle-option ${mode === 'advanced' ? 'active' : ''}`}
        onClick={() => onChange({ target: { value: 'advanced' } })}
      >
        <Icon
          type="setting"
          theme={mode === 'advanced' ? 'filled' : 'outlined'}
        />
        Dialogue
      </div>
      <div className={`toggle-slider ${mode}`} />
    </div>
  )
}

export default AudioModeToggle
